import React from 'react';
import { Link } from 'gatsby';
import OptimizedImage from '../../../OptimizedImage';

const SpecialBanner = () => {
  return (
    <OptimizedImage
      src="how-we-do/areyoucurious_bg_crop.png"
      background
      className="special-banner"
      style={{
        position: 'absolute'
      }}
    >
      <div className="special-banner-text">
        <div className="subtitle bigger without">
          Want to see the results of our work?
          <div className="extra">
            Learn about the projects we have delivered to our clients.
          </div>
        </div>
        <Link to="/case-studies/" className="btn btn-main">
          Go to case studies
        </Link>
      </div>
    </OptimizedImage>
  );
};

export default SpecialBanner;
